export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/hats.70720ad.svg";